module.exports = __webpack_public_path__ + "static/q-photo-logo-15422a2f073af5e551d74aecfe8611cd.png";